import { Link } from "react-router-dom";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";

export default function BillingCancel() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-red-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-xl border-0">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-red-100 flex items-center justify-center">
            <XCircle className="w-12 h-12 text-red-500" />
          </div>
          
          <h1 className="text-2xl font-bold text-slate-900 mb-2">
            Pagamento non completato
          </h1>
          
          <p className="text-slate-600 mb-8">
            Il pagamento è stato annullato o non è andato a buon fine. 
            Puoi riprovare quando vuoi.
          </p>
          
          <div className="space-y-3">
            <Link to="/register">
              <Button className="w-full bg-blue-600 hover:bg-blue-700">
                <RefreshCw className="w-4 h-4 mr-2" />
                Riprova la registrazione
              </Button>
            </Link>
            
            <Link to="/login">
              <Button variant="outline" className="w-full">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Torna al login
              </Button>
            </Link>
          </div>
          
          <p className="text-sm text-slate-500 mt-6">
            Hai bisogno di assistenza? <br />
            Contattaci a <a href="mailto:supporto@affidya.it" className="text-blue-600 hover:underline">supporto@affidya.it</a>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
